<!-- Phones: a two-column grid, so a row action drops under the label while the control stays
     level with the label. Desktop: one flex line with the label column at a fixed minimum. -->
<div
  class="edit-transaction-sheet-row grid w-full grid-cols-[minmax(0,1fr)_minmax(0,var(--app-size-edit-transaction-control))] items-center gap-x-(--app-space-field-inline) gap-y-2 md:flex md:justify-between"
>
  <div
    class="edit-transaction-sheet-row__label contents text-body-sm leading-tight text-text-muted md:flex md:min-w-(--app-size-edit-transaction-label) md:items-center md:gap-2"
  >
    <span class="edit-transaction-sheet-row__heading col-start-1 row-start-1 flex items-center gap-2 whitespace-nowrap">
      <app-ui-icon [name]="icon()" class="h-4 w-4" />
      <span>{{ label() }}</span>
    </span>
    <div class="edit-transaction-sheet-row__action col-start-1 row-start-2 flex items-center justify-self-start empty:hidden">
      <ng-content select="[rowAction]" />
    </div>
  </div>
  <div
    class="edit-transaction-sheet-row__control col-start-2 row-start-1 flex min-w-0 items-center empty:hidden md:ml-auto md:w-(--app-size-edit-transaction-control)"
  >
    <ng-content />
  </div>
</div>
